import React, { useState, useEffect } from 'react';
import { ToastContainer, toast } from 'react-toastify';
import { Button, Modal, Row, Col, Form, OverlayTrigger } from "react-bootstrap";
import { MdEdit, MdAddCircle, MdFilterList, MdDelete } from "react-icons/md";
import { useNavigate } from "react-router-dom";

import axios from "axios";
import DataTable from "react-data-table-component";
import { Tooltip } from '@mui/material';
import loading from "../../assets/images/common/loading.gif";
import AppDataGrid from "../../components/common/AppDataGrid";


const Buses = () => {
    const [buses, setBuses] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [searchQuery, setSearchQuery] = useState("");
    const [showFilterModal, setShowFilterModal] = useState(false);
    const handleCloseFilterModal = () => setShowFilterModal(false);
    const handleShowFilterModal = () => setShowFilterModal(true);
    const baseUrl = process.env.REACT_APP_API_BASE_URL;
    const navigate = useNavigate();
    const userData = sessionStorage.getItem('user');
    const [showDocsModal, setShowDocsModal] = useState(false);
const [selectedDocs, setSelectedDocs] = useState([]);

const handleShowDocuments = (docs) => {
  setSelectedDocs(docs);
  setShowDocsModal(true);
};
    const userObj = JSON.parse(userData);
    const [form, setForm] = useState({
        bus_id: "",
        bus_number: "",
       capacity:"",
       model:"",
       registration_no:"",
       driver_id:"",

        school_id: "",
        action: "FILTER"
    });
    useEffect(() => {
        setIsLoading(true);
        fetchData().finally(() => setIsLoading(false));
    }, []);

    const handleEditClick = (vehicle_id) => {
        const employeemasterToEdit = buses.find(bus => bus.vehicle_id === vehicle_id);

        if (employeemasterToEdit) {
            navigate("/addbuses", { state: { busesData: employeemasterToEdit } });
        } else {
            console.error(`buses with ID ${vehicle_id} not found.`);
        }
    };
    const fetchData = async () => {
        try {
            const response = await axios.post(baseUrl + "/vehicle/", {
                action: "READ",
                school_id: userObj.school_id
            });

            setBuses(response.data);
        } catch (error) {
            console.log("Error fetching data:", error);
        }
    };

    const handleDeleteClick = async (vehicle_id) => {
        const confirmDelete = window.confirm('Are you sure you want to change the status?');

        if (!confirmDelete) {
            return;
        }
        const requestBody = {
            vehicle_id: vehicle_id,
            action: "DELETE"
        };

        try {
            const response = await axios.post(baseUrl + '/vehicle/', requestBody, {
                headers: {
                    'Content-Type': 'application/json'
                },
            });
            if (response.status < 200 || response.status >= 300) {
                throw new Error(`HTTP error! Status: ${response.status}`);
            }
            toast.success("Record Set To InActive ");
            fetchData();
        } catch (error) {
            console.error('Error:', error);
        }
    };

    const searchableColumns = [
    (row) => row.model,
    (row) => row.status,
    (row) => row.last_service_date,
];


    const normalizedQuery = (searchQuery || '').toLowerCase().replace(/[-\s]+/g, '');

    const filteredRecords = (buses || []).filter((item) =>
  searchableColumns.some((selector) => {
    const value = selector(item);
    if (!value) return false;

    let stringValue = value.toString().toLowerCase().replace(/[-\s]+/g, '');

    // 🧠 Handle date format (convert YYYY-MM-DD → DD-MM-YYYY)
    if (/^\d{4}-\d{2}-\d{2}$/.test(value)) {
      const [year, month, day] = value.split("-");
      const ddmmyyyy = `${day}-${month}-${year}`;
      stringValue += ddmmyyyy.replace(/[-\s]+/g, '');
    }

    return stringValue.includes(normalizedQuery);
  })
);


    const hasRecords = filteredRecords.length > 0;



    const baseColumns = [
        // {
        //     name: 'Bus Number',
        //     selector: (row) => row.bus_number,
        //     cell: (row) => <Tooltip title={row.bus_number}><span>{row.bus_number}</span></Tooltip>,
        //     sortable: true,
        // },
        
        {
            name: 'Model',
            selector: (row) => row.model,
            cell: (row) => <Tooltip title={row.model}><span>{row.model}</span></Tooltip>,
            sortable: true,
        },
        {
            name: 'Last Service Date',
            selector: (row) => row.last_service_date,
            cell: (row) => <Tooltip title={row.last_service_date}><span>{row.last_service_date}</span></Tooltip>,
            sortable: true,
        },
        {
            name: 'Status',
            selector: (row) => row.status,
            cell: (row) => <Tooltip title={row.status}><span>{row.status}</span></Tooltip>,
            sortable: true,
        },
        // {
        //     name: 'Driver Name',
        //     selector: (row) => row.driver_name,
        //     cell: (row) => <Tooltip title={row.driver_name}><span>{row.driver_name}</span></Tooltip>,
        //     sortable: true,
        // },  


    ];
   const columns = [
  {
    field: "model",
    headerName: "Model",
    flex: 1,
    headerAlign: "center",
    align: "center",
    sortable: true,
    renderCell: (params) => (
      <Tooltip title={params.value}>
        <span className="cell-wrap">{params.value}</span>
      </Tooltip>
    ),
  },
  {
  field: "last_service_date",
  headerName: "Last Service Date",
  flex: 1,
  headerAlign: "center",
  align: "center",
  sortable: true,
  renderCell: (params) => {
    let formattedDate = "";
    if (params.value) {
      const date = new Date(params.value);
      // Format as DD-MM-YYYY with hyphens
      formattedDate = date
        .toLocaleDateString("en-GB", {
          day: "2-digit",
          month: "2-digit",
          year: "numeric",
        })
        .replace(/\//g, "-"); // replace slashes with hyphens
    }
    return (
      <Tooltip title={formattedDate}>
        <span className="cell-wrap">{formattedDate}</span>
      </Tooltip>
    );
  },
}

,
{
  field: "documents",
  headerName: "Documents",
  flex: 1,
  headerAlign: "center",
  align: "center",
  sortable: false,
  renderCell: (params) => {
    const docs = params.value;

    return docs && docs.length > 0 ? (
      <a
        href="#"
        onClick={(e) => {
          e.preventDefault();
          handleShowDocuments(docs);
        }}
        style={{ color: "#007bff", cursor: "pointer" }}
      >
        Documents
      </a>
    ) : (
      <span></span>
    );
  },
}

,
  {
    field: "status",
    headerName: "Status",
    flex: 1,
    headerAlign: "center",
    align: "center",
    sortable: true,
    renderCell: (params) => (
      <Tooltip title={params.value}>
        <span className="cell-wrap">{params.value}</span>
      </Tooltip>
    ),
  },
  ...(true // replace with your `canSubmit` condition if needed
    ? [
        {
          field: "actions",
          headerName: "Actions",
          flex: 1,
          headerAlign: "center",
          align: "center",
          sortable: false,
          renderCell: (params) =>
            params.row.registration_no !== "No records found" ? (
              <div className="tableActions">
                <Tooltip title="Edit" arrow>
                  <span
                    className="commonActionIcons"
                    onClick={() => handleEditClick(params.row.vehicle_id)}
                  >
                    <MdEdit />
                  </span>
                </Tooltip>
                <Tooltip title="Delete" arrow>
                  <span
                    className="commonActionIcons"
                    onClick={() => handleDeleteClick(params.row.vehicle_id)}
                  >
                    <MdDelete />
                  </span>
                </Tooltip>
              </div>
            ) : null,
        },
      ]
    : []),
];



    const handleInputChange = (e) => {
        const { id, value } = e.target;

        setForm((prevForm) => ({
            ...prevForm,
            [id]: value
        }));
    };


    const handleSubmit = async (e) => {
        e.preventDefault();

        const formData = {
            model: form.model,
            school_id: userObj.school_id,
            action: 'FILTER',
        };

        try {
            const response = await axios.post(baseUrl + "/vehicle/", formData, {
                headers: {
                    "Content-Type": "application/json",
                },
            });

            const data = response.data;

            if (
                data &&
                typeof data === "object" &&
                data.message === "No data found for action: FILTER"
            ) {
                setBuses([]);
                setShowFilterModal(false);

            } else if (Array.isArray(data)) {
                setBuses(data);
                setShowFilterModal(false);
            } else {
                setBuses([]);
                setShowFilterModal(false);
            }

        } catch (error) {
            console.error("Error fetching filtered data:", error);
            setBuses([]);
            setShowFilterModal(false);
        }
    };


    const handleReset = async (e) => {
        e.preventDefault();
        setForm({
            model: "",
        });
        setShowFilterModal(true);
        fetchData();
    };
    const handleSearchChange = (event) => {
        setSearchQuery(event.target.value);
    };

    return (
       

                <div className="pageBody">
                    <ToastContainer />
                    <div className="commonDataTableHead">
                        <div className="d-flex justify-content-between align-items-center w-100">
                            <div className="d-flex align-items-center" style={{ gap: "10px" }}>
                                <h6 className="commonTableTitle"> Vehicle Master</h6>
                            </div>
                            <div className="">
                                <input
                                    type="text"
                                    placeholder="Search..."
                                    value={searchQuery}
                                    className="searchInput"
                                    onChange={handleSearchChange}
                                />
                            </div>
                            <div className="d-flex align-items-center" style={{ gap: 6 }}>
                                <OverlayTrigger placement="top" overlay={<Tooltip id="tooltip-top">Filter</Tooltip>}>
                                    <Button className="secondaryBtn" variant="secondary" onClick={handleShowFilterModal}>
                                        <MdFilterList />
                                    </Button>
                                </OverlayTrigger>
                                {
                                    <OverlayTrigger placement="top" overlay={<Tooltip id="tooltip-top">Add</Tooltip>}>
                                        <Button className="primaryBtn" variant="primary" onClick={() => navigate("/addbuses")}>
                                            <MdAddCircle />
                                        </Button>
                                    </OverlayTrigger>
                                }
                            </div>
                        </div>
                    </div>
                    <div className="commonTable height100">
                        <div className="tableBody">
                            {isLoading ? (
                                <div className="loadingContainer">
                                    <img src={loading} alt="Loading..." className="loadingGif" />
                                </div>
                            ) : (
                                 <AppDataGrid
                                                        rows={filteredRecords}
                                                        columns={columns}
                                                        getRowId={(r) => r.vehicle_id}
                                                        showToolbar={false}
                                                        pagination
                                                        pageSizeOptions={[10, 20, 50]}
                                                        density="compact"
                                                        maxHeight={500}  
                                                    />
                            )}
                        </div>
                    </div>
               
            <Modal show={showFilterModal} onHide={handleCloseFilterModal} className="commonFilterModal">
                <Modal.Header closeButton className="modalHeaderFixed">
                    <Modal.Title>Filter</Modal.Title>
                </Modal.Header>
                <Modal.Body className="modalBodyScrollable">
                    <Row>
                        <Col xs={12}>
                            <div className="commonInput">
                                <Form.Group controlId="levelName">
                                    <Form.Label>Model</Form.Label>
                                    <Form.Control
                                        type="text"
                                        id="model"
                                        value={form.model}
                                        placeholder="Enter Model"
                                        onChange={handleInputChange}
                                        // onKeyDown={(e) => {
                                        //     if (e.key === ' ' && e.target.selectionStart === 0) {
                                        //         e.preventDefault();
                                        //     }
                                        // }}
                                        maxLength={30}
                                    />
                                </Form.Group>
                            </div>
                        </Col>

                    </Row>
                </Modal.Body>
                <Modal.Footer className="modalFooterFixed">
                    <Button variant="secondary" className="btn-info clearBtn me-2" onClick={handleReset}>
                        Reset
                    </Button>
                    <div>
                        <Button variant="secondary" className="btn-danger secondaryBtn me-2" onClick={() => { handleCloseFilterModal(); }}>
                            Cancel
                        </Button>

                        <Button variant="primary" className="btn-success primaryBtn" onClick={handleSubmit}>
                            Search
                        </Button>
                    </div>
                </Modal.Footer>
            </Modal>
          <Modal
  show={showDocsModal}
  onHide={() => setShowDocsModal(false)}
  centered
>
  <Modal.Header closeButton>
    <Modal.Title>Documents</Modal.Title>
  </Modal.Header>
  <Modal.Body style={{ whiteSpace: "pre-wrap", wordWrap: "break-word" }}>
    {selectedDocs.length > 0 ? (
      selectedDocs.map((doc, idx) => (
        <div key={idx} style={{ marginBottom: "10px" }}>
          <p><strong>Document Name:</strong> {doc.document_name || "-"}</p>
          <p><strong>Document Number:</strong> {doc.document_number || "-"}</p>
          <p>
            <strong>Attachment:</strong>{" "}
            {doc.attachment ? (
              <a
                href={`${baseUrl}/uploads/get-image/${encodeURIComponent(
                  doc.attachment.replace(/^uploads[\\/]/, "")
                )}`}
                target="_blank"
                rel="noopener noreferrer"
                download={doc.attachment.split(/[\\/]/).pop()}
              >
                {doc.attachment.split(/[\\/]/).pop()}
              </a>
            ) : (
              ""
            )}
          </p>
          {idx !== selectedDocs.length - 1 && <hr />}
        </div>
      ))
    ) : (
      <p>No documents available.</p>
    )}
  </Modal.Body>
  <Modal.Footer>
    <Button variant="secondary" onClick={() => setShowDocsModal(false)}>
      Close
    </Button>
  </Modal.Footer>
</Modal>

        </div>
    );
};

export default Buses;
